import { AlertCircle } from "lucide-react";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";

interface TokenWarningBannerProps {
  usagePercentage: number;
  onPurchase: () => void;
}

export function TokenWarningBanner({ usagePercentage, onPurchase }: TokenWarningBannerProps) {
  // Return null if usagePercentage is undefined or less than 80
  if (!usagePercentage || usagePercentage < 80) return null;

  // Ensure usagePercentage is a valid number
  const formattedPercentage = Number(usagePercentage).toFixed(0);

  return (
    <Alert variant="default" className="mb-4 border-amber-200 bg-amber-50">
      <AlertCircle className="h-4 w-4 text-amber-600" />
      <AlertDescription className="flex items-center justify-between text-amber-800">
        <span>
          Du har brukt {formattedPercentage}% av dine månedlige tokens.
          {usagePercentage >= 90 && " Det anbefales å kjøpe flere tokens snart."}
        </span>
        <Button 
          variant="outline" 
          size="sm" 
          onClick={onPurchase}
          className="border-amber-200 hover:bg-amber-100 hover:text-amber-900"
        >
          Kjøp tokens
        </Button>
      </AlertDescription>
    </Alert>
  );
}